import React, { Component } from 'react';
import {connect} from 'react-redux';
import ga from 'analytics';

import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import {fetchMyProfile} from 'actions/user.js';
import SurveyPageUserProfile from './SurveyPageUserProfile.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';

class SurveyPageUserProfileContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {
                      validDateText:true,
                      userProfile:props.userProfile,
                      showChoosePhoto:false
            };
        this.state = this.props.savedState || this.initialState;
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onShowChoosePhoto = this.onShowChoosePhoto.bind(this);
        this.onHideChoosePhoto = this.onHideChoosePhoto.bind(this);
        this.onSaveUserPhoto   = this.onSaveUserPhoto.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-user-profile' }); 
    }

    onSubmit(event) {
        if(event) {
            event.preventDefault();
        }
        var avatar = this.state.userProfile.avatar;
        var avatarUpdate;
        if(avatar && avatar.dataURL) {
            avatarUpdate = {dataURL:avatar.dataURL};
        }
        var userProfileUpdate = {
                                    firstName:this.state.userProfile.firstName,
                                    lastName :this.state.userProfile.lastName,
                                    avatar:avatarUpdate
                                };
        var userChallenge = {
                                challengeId:this.props.surveyPage.challenge.id,
                                data: userProfileUpdate
                            };
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        DatabaseService.updateProfile({ userProfile : userProfileUpdate})
                       .then(() => this.props.onSubmit(null,userChallenge,this.state))
                       .catch(error => console.error('SurveyPageUserProfileContainer: ', error))
                       .then(()=>{
                           this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
                       });
    }

    onChange(event) {
        var {name, value} = event.target;
        this.updateState(name, value);
    }

    updateState(name, value) {
        this.setState((prevState, props) => (Utils.set({...prevState}, name, value)));
    }

    onShowChoosePhoto() {
        this.setState({showChoosePhoto:true});
    }
    onHideChoosePhoto() {
        this.setState({showChoosePhoto:false});
    }
    onSaveUserPhoto(photo) {
        this.updateState('userProfile.avatar', {dataURL:photo, url:photo});
        return Promise.resolve();
    }

    isValid() {
        return  (this.state.userProfile.firstName &&
                 this.state.userProfile.lastName);
    }

    render() {
        return <SurveyPageUserProfile
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   onSubmit={this.onSubmit}

                   valid={this.isValid()}
                   userProfile={this.state.userProfile}
                   onChange={this.onChange}
                   onShowChoosePhoto={this.onShowChoosePhoto}
                   onHideChoosePhoto={this.onHideChoosePhoto}
                   onSaveUserPhoto={this.onSaveUserPhoto}
                   showChoosePhoto={this.state.showChoosePhoto}
                   />;
    }

}


const mapStateToProps = (state, ownProps) => {
    return { userProfile:getUserProfileWithDefaults(state.user) };
}
export default connect(mapStateToProps)(SurveyPageUserProfileContainer);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageUserProfileContainer.js